exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/apps/asna/front-end/public_html/src/app/components/footer/footer.component.css
// module id = ../../../../../src/app/components/footer/footer.component.css
// module chunks = main